import React, { useEffect } from "react";
import UniqueCode from './UniqueCode';
import Training from './Training';
import Traineedetails from './Traineedetails';
import Certificate from './Certificate';
import Quiz from './Quiz';
import getBrowserFingerprint from 'get-browser-fingerprint';
import FeedbackSurvey from "./FeedbackSurvey";
import { use } from "i18next";
import { Base64 } from 'js-base64';

const Dashboard = ({page}) => {
    const fingerprint = getBrowserFingerprint();
    const pidVal = localStorage.getItem('PID');
    if(pidVal){
        page = Base64.decode(pidVal);
    }

    // useEffect(() => {
    //     if(page === undefined || page === null || page === '' ){
    //         localStorage.setItem("PID", window.btoa(fingerprint + "P1"));
    //     }
    //     else if(fingerprint+'P2' ===page || fingerprint+'P3'===page || fingerprint+'P4'===page || fingerprint+'P5' ===page || fingerprint+'P6' ===page){
    //         localStorage.setItem("PID", window.btoa(fingerprint + "P2"));
    //     }
    //     else {
    //         localStorage.setItem("PID", window.btoa(fingerprint + "P1"));
    //     }
    // }, [fingerprint]);

    const pageName = () => {      
        switch(page) {  
            case fingerprint+'P3':
                return "Training module page"
            case fingerprint+'P2':
                return "Trainee details form page"
            case fingerprint+'P4':
                return "Quiz page"
                case fingerprint+'P5':
                return "Feedback Survey page"
            default:
                return "Unique code landing page"
        }
    }
    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "customEvent",
          eventCategory: "Page Change",
          eventAction: pageName(page),
          eventLabel: pageName(page),
        });
      }, []);

    return (
        <>
            {(() => {
                switch (page) {
                    case    fingerprint+'P1': return (<UniqueCode/>)
                    case    fingerprint+'P2': return (<Traineedetails  />)
                    case    fingerprint+'P3': return (<Training/>)
                    case    fingerprint+'P4': return (<Quiz/>)  
                    case    fingerprint+'P5': return (<FeedbackSurvey/>)
                    case    fingerprint+'P6': return (<Certificate />)
                    default: return (<UniqueCode/>)
                }
            })()}
        </>
    );
};
export default Dashboard